// src/utils/examPopup.js
// Opens exam-mode popup windows with browser chrome suppressed, so they
// reliably read as a genuine popup window rather than a new tab.
//
// Real exam software (e.g. the ACCA CBE) opens exhibits/requirements/word
// processor/spreadsheet as SMALL windows that the candidate then resizes and
// arranges themselves - that resizing is itself part of what a student needs
// practice with, so these default small (pass explicit width/height) rather
// than large. The one exception is the exam session window itself, which is
// the student's primary workspace for the whole task - that one passes
// widthPct/heightPct instead, sized generously against the actual screen.
// A window sized close to the full screen is visually hard to tell apart
// from a maximized tab even when it's technically a separate window, which
// is exactly why these default small - the size difference is what makes it
// unmistakably a floating window.
export function openExamPopup(url, name, { widthPct, heightPct, width, height } = {}) {
  const availWidth = window.screen?.availWidth || window.innerWidth;
  const availHeight = window.screen?.availHeight || window.innerHeight;
  const w = width || Math.round(availWidth * (widthPct ?? 0.85));
  const h = height || Math.round(availHeight * (heightPct ?? 0.85));
  const left = Math.round((availWidth - w) / 2);
  const top = Math.round((availHeight - h) / 2);

  const features = [
    `width=${w}`, `height=${h}`, `left=${left}`, `top=${top}`,
    'toolbar=0', 'location=0', 'menubar=0', 'status=0', 'directories=0',
    'scrollbars=1', 'resizable=1'
  ].join(',');

  return window.open(url, name, features);
}
